import { render, staticRenderFns } from "./LeaguePlayerCard.vue?vue&type=template&id=55349b84"
import script from "./LeaguePlayerCard.vue?vue&type=script&lang=js"
export * from "./LeaguePlayerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports